import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// import { useQueryClient } from '@tanstack/react-query';
import { useLocation, useNavigate } from '@rocketlane/rocket-router';
import { kebabCase } from 'lodash';
import moment from 'moment';
import { memo, useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { UserType } from 'api/models';
import { PageLoading } from 'components/atoms/loading';
import { getCurrentApiHost } from 'config/environment';
import { useCurrentUserSideEffects } from 'contexts/providers';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';
import { useUser, useUserSafe } from 'hooks/use-user';
import { useAccountConfigQuery, useAccountDataQuery } from 'queries/account';
import { usePermissionSetDefinitionsForCtxMap } from 'queries/rbac';
import { ApiKey, logger } from 'services';
import { TOKEN_EXPIRY_KEY } from 'services/api-key';
import { getRGBFromHex } from 'utils/get-rgb-from-hex';
import { isNitroEnvironment } from 'utils/is-nitro-env';
import { rlNavigation } from 'utils/navigation';
import { addHopIdToSessionStorage } from 'utils/window-utils';
import { unregister } from 'vendor/cache-worker';
const LoadDependents = ({ onComplete })=>{
    const history = useNavigate();
    const location = useLocation();
    useCurrentUserSideEffects();
    // const dispatch = useDispatch();
    // const translate = useTranslate();
    // const companiesStore = useSelector(({ companies }: RootState) => companies);
    // const usersStore = useSelector(({ users }: RootState) => users);
    // const teamsStore = useSelector(({ teams }: RootState) => teams);
    // const membershipsStore = useSelector(
    //   ({ memberships }: RootState) => memberships,
    // );
    // const [fieldsLoaded, setFieldsLoaded] = useState(false);
    // const { data: projectsData } = useProjectsFromInitData();
    // const queryClient = useQueryClient();
    // useAllFieldsQuery({
    //   onSuccess: () => {
    //     const allFields = queryClient.getQueryData(
    //       ALL_FIELDS_QUERY_KEY,
    //     ) as Field[];
    //     dispatch(putAll(allFields));
    //     setFieldsLoaded(true); // this is enough as dispacth is synchronous
    //   },
    // });
    const { user: currentUser } = useUser();
    const { userType, userId } = currentUser;
    // const { systemBotId } = useAccount();
    // useEffect(() => {
    //   // if (!fieldsLoaded) {
    //   //   return;
    //   // }
    //   dispatch(
    //     refresh([
    //       usersStore,
    //       teamsStore,
    //       membershipsStore,
    //       companiesStore,
    //       CompanyId(companyId),
    //       currentUser,
    //       currentUser.userType === UserType.Native ? systemBotId : undefined,
    //       projectsData,
    //       filterPointsFieldsFromTaskFields,
    //       isSprintPlaningFeatureEnabled,
    //       translate,
    //     ]),
    //   );
    // }, [
    //   companiesStore,
    //   companyId,
    //   currentUser,
    //   dispatch,
    //   membershipsStore,
    //   systemBotId,
    //   teamsStore,
    //   usersStore,
    //   projectsData,
    //   filterPointsFieldsFromTaskFields,
    //   isSprintPlaningFeatureEnabled,
    //   translate,
    // ]);
    useEffect(()=>{
        if (userType === UserType.External) {
            window.setTimeout(()=>onComplete());
        }
    }, [
        onComplete,
        userType
    ]);
    // Hack way, to set history to rlNavigation
    // But to remove connected-react-router, we need to do this
    useEffect(()=>{
        rlNavigation.set(history, location);
    }, [
        history,
        location
    ]);
    // Setting hopId for tabs unique per user
    useEffect(()=>{
        addHopIdToSessionStorage(userId);
    }, [
        userId
    ]);
    useEffect(()=>{
        const updateApiKey = async ()=>{
            try {
                var _ref;
                var _ApiKey_get;
                const resp = await fetch(`${getCurrentApiHost()}/api/v1/token-auth/jwt-auth`, {
                    headers: {
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        'Api-key': (_ref = (_ApiKey_get = ApiKey.get()) === null || _ApiKey_get === void 0 ? void 0 : _ApiKey_get[1]) !== null && _ref !== void 0 ? _ref : ''
                    },
                    credentials: 'same-origin'
                });
                const respData = await resp.json();
                if (respData === null || respData === void 0 ? void 0 : respData.newAuthExpiryTimestamp) {
                    localStorage.setItem(TOKEN_EXPIRY_KEY, respData === null || respData === void 0 ? void 0 : respData.newAuthExpiryTimestamp);
                }
            } catch (e) {
                logger.error('Error while fetching token', e);
            }
        };
        if (!isNitroEnvironment()) {
            return;
        }
        const authExpiryTS = localStorage.getItem(TOKEN_EXPIRY_KEY);
        if (ApiKey.get() !== null && authExpiryTS === null) {
            updateApiKey();
        }
    }, []);
    useEffect(()=>{
        const refreshToken = async ()=>{
            try {
                const resp = await fetch(`${getCurrentApiHost()}/api/v1/token-auth/refresh`, {
                    credentials: 'same-origin'
                });
                const respData = await resp.json();
                if (respData === null || respData === void 0 ? void 0 : respData.newAuthExpiryTimestamp) {
                    localStorage.setItem(TOKEN_EXPIRY_KEY, respData === null || respData === void 0 ? void 0 : respData.newAuthExpiryTimestamp);
                }
            } catch (e) {
                logger.error('Error while refreshing token', e);
            }
        };
        if (!isNitroEnvironment()) {
            return;
        }
        const authExpiryLS = localStorage.getItem(TOKEN_EXPIRY_KEY);
        if (authExpiryLS !== null) {
            const expiryInt = parseInt(authExpiryLS, 10);
            if (expiryInt === -1 || currentUser.userType === UserType.External) {
                return;
            }
            const authExpiry = moment.unix(expiryInt);
            const now = moment();
            const diff = authExpiry.diff(now, 'days');
            if (diff < 30) {
                refreshToken();
            }
        }
    }, [
        currentUser.userType
    ]);
    // Setting hopId for tabs unique per user
    useEffect(()=>{
        addHopIdToSessionStorage(userId);
    }, [
        userId
    ]);
    useEffect(()=>{
        unregister(userId);
    }, [
        userId
    ]);
    return null;
};
const UserProfileGuard = ({ children })=>{
    const userProfile = useUserSafe();
    if (!userProfile) {
        return /*#__PURE__*/ _jsx(PageLoading, {
            css: true
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
const RenderBootApp = ({ children, isAccountDataFetched, onDependentsLoaded })=>{
    return isAccountDataFetched ? /*#__PURE__*/ _jsxs(UserProfileGuard, {
        children: [
            /*#__PURE__*/ _jsx(LoadDependents, {
                onComplete: onDependentsLoaded
            }),
            children
        ]
    }) : /*#__PURE__*/ _jsx(PageLoading, {
        css: true
    });
};
const stopRerenderPostLoading = (pre)=>!!pre.isLoading;
const MuteBootUpdatesPostLoading = /*#__PURE__*/ memo(RenderBootApp, stopRerenderPostLoading);
export const LazyBootApp = ({ children })=>{
    const [isLoading, setLoading] = useState(false);
    // const dispatch = useDispatch();
    const [dependentsLoaded, setDependentsLoaded] = useState(false);
    const { isSuccess: isAccountDataFetched, data: accountData } = useAccountDataQuery();
    const { isSuccess: isAccountConfigFetched } = useAccountConfigQuery();
    // const { isSuccess: isTaskFieldsFetched } = useTaskFieldsQuery({
    //   onSuccess: (result) => {
    //     dispatch(saveFields(result));
    //   },
    // });
    // const [membersDataLoadedIntoIndexedDB, setMembersDataLoadedIntoIndexedDB] =
    //   useState(false);
    // const { isSuccess: isMembersV2Fetched, data } = useMembersV2Query({}, () => {
    //   setMembersDataLoadedIntoIndexedDB(true);
    // });
    const { isSuccess: isPermissionSetDefinitionFetched } = usePermissionSetDefinitionsForCtxMap();
    // usePrerenderMembersAndTeamsFromIndexedDb();
    useEffect(()=>{
        if ((isAccountDataFetched || accountData) && isAccountConfigFetched && // isTaskFieldsFetched &&
        dependentsLoaded) {
            requestAnimationFrame(()=>setLoading(true));
        }
    }, [
        isAccountDataFetched,
        isAccountConfigFetched,
        // isTaskFieldsFetched,
        dependentsLoaded,
        // isMembersV2Fetched,
        // membersDataLoadedIntoIndexedDB,
        accountData
    ]);
    const onDependentsLoaded = useCallback(()=>{
        setDependentsLoaded(true);
    }, []);
    const [, setTimesheetsFeature] = useAccountFeature(AccountFeature.Timesheets);
    const [, setFinancialsFeature] = useAccountFeature(AccountFeature.Financials);
    const [, setSprintsFeature] = useAccountFeature(AccountFeature.SprintPlanning);
    const [, setInvoicesFeature] = useAccountFeature(AccountFeature.Invoices);
    const [, setCreditNotesFeature] = useAccountFeature(AccountFeature.CreditNotes);
    const [, setAiFillsFeature] = useAccountFeature(AccountFeature.AiFills);
    const [, setAiFilterFeature] = useAccountFeature(AccountFeature.AiFilter);
    const [, setExpenseFeature] = useAccountFeature(AccountFeature.Expenses);
    const [, setForcePrivateAttachmentsFeature] = useAccountFeature(AccountFeature.ForcePrivateAttachments);
    const [, setTimesheetPoliciesFeature] = useAccountFeature(AccountFeature.TimesheetPolicies);
    const [, setScimFeature] = useAccountFeature(AccountFeature.Scim);
    const [, setRestrictUserGroupsFeature] = useAccountFeature(AccountFeature.RestrictUserGroups);
    const [, setPartnerRbacFeature] = useAccountFeature(AccountFeature.PartnerRbac);
    const [, setMultiLineBudgetsFeature] = useAccountFeature(AccountFeature.MultiLineBudgets);
    const [, setEmailIntelligenceFeature] = useAccountFeature(AccountFeature.EmailIntelligence);
    const [, setMigrationAgentFeature] = useAccountFeature(AccountFeature.MigrationAgent);
    const [, setProjectGovernancePoliciesFeature] = useAccountFeature(AccountFeature.PolicyEvaluation);
    const [, setWorkforceAgentFeature] = useAccountFeature(AccountFeature.WorkforceAgent);
    const [, setWorkforceAgentBuilderFeature] = useAccountFeature(AccountFeature.WorkforceAgentBuilderEnabled);
    const [, setNitroClawFeature] = useAccountFeature(AccountFeature.NitroClaw);
    const [, setAutopilotAgentFeature] = useAccountFeature(AccountFeature.AutopilotAgent);
    const [, setCustomReportsBudgetSourceTabularFeature] = useAccountFeature(AccountFeature.CustomReportsBudgetSourceTabular);
    const [, setCustomReportsBudgetSourcePivotFeature] = useAccountFeature(AccountFeature.CustomReportsBudgetSourcePivot);
    const [, setOverallFinancialsOptimizationFeature] = useAccountFeature(AccountFeature.OverallFinancialsOptimization);
    const [, setSlackPvtChannelsFeature] = useAccountFeature(AccountFeature.SlackPvtChannels);
    const [, setRmAggregationsOptFeature] = useAccountFeature(AccountFeature.RmAggregationsOpt);
    const [, setLitePayloadRefactorFeature] = useAccountFeature(AccountFeature.LitePayloadRefactor);
    const [, setNetsuiteIntegrationFeatureEnabled] = useAccountFeature(AccountFeature.NetsuiteIntegration);
    const [, setOpenuiFeature] = useAccountFeature(AccountFeature.Openui);
    useLayoutEffect(()=>{
        if (accountData) {
            var _ref;
            const { account: { metaData }, accountMeta: { features }, restrictUserGroups, partnerRbacEnabled } = accountData;
            if (metaData) {
                const { theme } = metaData;
                if (theme) {
                    const root = document.documentElement;
                    Object.keys(theme).forEach((variable)=>{
                        const variableValue = theme[variable];
                        if (variableValue) {
                            root.style.setProperty(`--${kebabCase(variable)}`, variableValue);
                        }
                    });
                    if (theme.brandColorInRgb == null) {
                        const themeBrandInNum = theme === null || theme === void 0 ? void 0 : theme.brandColor.slice(1);
                        root.style.setProperty(`--${kebabCase('brandColorInRgb')}`, `${getRGBFromHex(themeBrandInNum)[0]}, ${getRGBFromHex(themeBrandInNum)[1]}, ${getRGBFromHex(themeBrandInNum)[2]}`);
                    }
                }
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.Timesheets]) != null) {
                setTimesheetsFeature(features[AccountFeature.Timesheets]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.Financials]) != null) {
                setFinancialsFeature(features[AccountFeature.Financials]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.SprintPlanning]) != null) {
                setSprintsFeature(features[AccountFeature.SprintPlanning]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.Invoices]) != null) {
                setInvoicesFeature(features[AccountFeature.Invoices]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.CreditNotes]) != null) {
                setCreditNotesFeature(features[AccountFeature.CreditNotes]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.AiFills]) != null) {
                setAiFillsFeature(features[AccountFeature.AiFills]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.AiFilter]) != null) {
                setAiFilterFeature(features[AccountFeature.AiFilter]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.Expenses]) != null) {
                setExpenseFeature(features[AccountFeature.Expenses]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.ForcePrivateAttachments]) != null) {
                setForcePrivateAttachmentsFeature(features[AccountFeature.ForcePrivateAttachments]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.TimesheetPolicies]) != null) {
                setTimesheetPoliciesFeature(features[AccountFeature.TimesheetPolicies]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.Scim]) != null) {
                var _ref1;
                setScimFeature((_ref1 = features === null || features === void 0 ? void 0 : features[AccountFeature.Scim]) !== null && _ref1 !== void 0 ? _ref1 : false);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.MultiLineBudgets]) != null) {
                setMultiLineBudgetsFeature(features === null || features === void 0 ? void 0 : features[AccountFeature.MultiLineBudgets]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.EmailIntelligence]) != null) {
                setEmailIntelligenceFeature(features[AccountFeature.EmailIntelligence]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.MigrationAgent]) != null) {
                setMigrationAgentFeature(features[AccountFeature.MigrationAgent]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.PolicyEvaluation]) != null) {
                setProjectGovernancePoliciesFeature(features[AccountFeature.PolicyEvaluation]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.WorkforceAgent]) != null) {
                setWorkforceAgentFeature(features[AccountFeature.WorkforceAgent]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.WorkforceAgentBuilderEnabled]) != null) {
                setWorkforceAgentBuilderFeature(features[AccountFeature.WorkforceAgentBuilderEnabled]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.NitroClaw]) != null) {
                setNitroClawFeature(features[AccountFeature.NitroClaw]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.AutopilotAgent]) != null) {
                setAutopilotAgentFeature(features[AccountFeature.AutopilotAgent]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.CustomReportsBudgetSourceTabular]) != null) {
                setCustomReportsBudgetSourceTabularFeature(features[AccountFeature.CustomReportsBudgetSourceTabular]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.CustomReportsBudgetSourcePivot]) != null) {
                setCustomReportsBudgetSourcePivotFeature(features[AccountFeature.CustomReportsBudgetSourcePivot]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.OverallFinancialsOptimization]) != null) {
                setOverallFinancialsOptimizationFeature(features[AccountFeature.OverallFinancialsOptimization]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.SlackPvtChannels]) != null) {
                setSlackPvtChannelsFeature(features[AccountFeature.SlackPvtChannels]);
            }
            setRmAggregationsOptFeature((_ref = features === null || features === void 0 ? void 0 : features[AccountFeature.RmAggregationsOpt]) !== null && _ref !== void 0 ? _ref : false);
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.LitePayloadRefactor]) != null) {
                setLitePayloadRefactorFeature(features[AccountFeature.LitePayloadRefactor]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.NetsuiteIntegration]) != null) {
                setNetsuiteIntegrationFeatureEnabled(features[AccountFeature.NetsuiteIntegration]);
            }
            if ((features === null || features === void 0 ? void 0 : features[AccountFeature.Openui]) != null) {
                setOpenuiFeature(features[AccountFeature.Openui]);
            }
            setRestrictUserGroupsFeature(restrictUserGroups !== null && restrictUserGroups !== void 0 ? restrictUserGroups : false);
            setPartnerRbacFeature(partnerRbacEnabled !== null && partnerRbacEnabled !== void 0 ? partnerRbacEnabled : false);
        }
    }, [
        accountData,
        setFinancialsFeature,
        setTimesheetsFeature,
        setSprintsFeature,
        setInvoicesFeature,
        setAiFillsFeature,
        setAiFilterFeature,
        setExpenseFeature,
        setForcePrivateAttachmentsFeature,
        setTimesheetPoliciesFeature,
        setProjectGovernancePoliciesFeature,
        setScimFeature,
        setRestrictUserGroupsFeature,
        setPartnerRbacFeature,
        setMultiLineBudgetsFeature,
        setEmailIntelligenceFeature,
        setMigrationAgentFeature,
        setWorkforceAgentFeature,
        setWorkforceAgentBuilderFeature,
        setNitroClawFeature,
        setAutopilotAgentFeature,
        setCreditNotesFeature,
        setCustomReportsBudgetSourceTabularFeature,
        setCustomReportsBudgetSourcePivotFeature,
        setOverallFinancialsOptimizationFeature,
        setSlackPvtChannelsFeature,
        setRmAggregationsOptFeature,
        setLitePayloadRefactorFeature,
        setNetsuiteIntegrationFeatureEnabled,
        setOpenuiFeature
    ]);
    // TODO: Remove this CurrentUserProvider once we have a better way to handle this
    // load routes only when account data is fetched and indexdb is populated
    return /*#__PURE__*/ _jsx(MuteBootUpdatesPostLoading, {
        isAccountDataFetched: !!((isAccountDataFetched || accountData) && // (membersDataLoadedIntoIndexedDB || data) &&
        isPermissionSetDefinitionFetched),
        onDependentsLoaded: onDependentsLoaded,
        isLoading: isLoading,
        children: /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        })
    });
};
